// Global summa (pul) formatlash yordamchilari.
// Ming ajratkichi sifatida probel ishlatiladi: 1 000 000.5
// Butun loyiha bo'ylab summa inputlari va ko'rsatkichlari uchun yagona manba.

/**
 * Raqamni ming-ajratkichli matnga aylantiradi.
 * @param {number|string} value
 * @param {number} precision - maksimal kasr xonalari (default 2)
 * @returns {string}
 */
export function formatSumma(value, precision = 2) {
  if (value === null || value === undefined || value === '') return '0';
  let num = typeof value === 'number' ? value : parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
  if (isNaN(num)) return '0';
  const neg = num < 0;
  num = Math.abs(num);
  // precision bo'yicha yaxlitlash (ortiqcha nollarsiz)
  const factor = Math.pow(10, precision);
  num = Math.round(num * factor) / factor;
  const parts = String(num).split('.');
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const decPart = parts[1] ? '.' + parts[1] : '';
  return (neg ? '-' : '') + intPart + decPart;
}

/**
 * Foydalanuvchi kiritgan matndan toza son hosil qiladi.
 * @param {string|number} str
 * @returns {number}
 */
export function parseSumma(str) {
  if (str === null || str === undefined || str === '') return 0;
  let s = String(str).replace(/\s/g, '').replace(',', '.').replace(/[^0-9.\-]/g, '');
  const parts = s.split('.');
  if (parts.length > 2) s = parts[0] + '.' + parts.slice(1).join('');
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

/**
 * Foydalanuvchi yozayotgan matnni jonli formatlaydi (yozilayotgan kasr nuqtasini saqlaydi).
 * @param {string} raw - input.value
 * @param {number} precision
 * @returns {{ display: string, num: number }}
 */
export function buildSumma(raw, precision = 2) {
  let s = String(raw == null ? '' : raw).replace(/\s/g, '').replace(',', '.');
  s = s.replace(/[^0-9.]/g, '');
  const hasDot = s.indexOf('.') !== -1;
  let [intRaw = '', decRaw = ''] = s.split('.');
  // ketma-ket nuqtalardan keyingilarini birlashtirish
  if (s.split('.').length > 2) {
    const p = s.split('.');
    intRaw = p[0];
    decRaw = p.slice(1).join('');
  }
  intRaw = intRaw.replace(/^0+(?=\d)/, ''); // boshidagi ortiqcha nollar
  if (decRaw.length > precision) decRaw = decRaw.slice(0, precision);

  let intFmt = intRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  if (intRaw === '' && hasDot) intFmt = '0';

  let display = intFmt;
  if (hasDot) display += '.' + decRaw;

  const num = parseSumma((intRaw || '0') + (hasDot ? '.' + (decRaw || '0') : ''));
  return { display, num };
}

export default formatSumma;
